<template>
  <b-modal
    v-model="showModal"
    ref="modalSelectProduct"
    centered
    @hidden="hide"
    hide-ok
  >
    <template #modal-header>Releated Ticket</template>

    <div class="booking-header">
      <HeaderPanel
        title="BOOKING LIST"
        :filter="filter"
        placeholder="Search Booking ID"
        :hasDropdown="false"
        :hasFilter="false"
        @search="handleSearch"
        class="header"
      />
      <BookingTemplateCreate
        :isRedirect="false"
        @addBooking="($event) => $emit('addBooking', $event)"
      />
    </div>
    <b-table
      striped
      hover
      responsive
      :items="items"
      :fields="fields"
      :busy="isBusy"
      show-empty
      empty-text="No matching records found"
      class="mt-2"
    >
      <template v-slot:cell(prefix_id)="{ item }">
        <div>
          <router-link
            :to="`/booking/details/${item.booking_id}/${item.id}`"
            class="d-block underline text-bold"
          >
            {{ item.prefix_id }}
          </router-link>
          <router-link
            :to="`/setting/booking/template/${item.booking_id}`"
            class="d-block"
          >
            <span class="time-color"> {{ item.booking_name }}</span>
          </router-link>
        </div>
      </template>
      <template v-slot:cell(all_service_name)="{ item }">
        <div class="break-word">{{ item.all_service_name }}</div>
      </template>

      <template v-slot:cell(status)="{ item }">
        <span :class="colorClass(item)">{{ item.status_name }}</span>
      </template>
      <template v-slot:cell(actions)="{ item }">
        <div class="d-flex justify-content-center">
          <router-link :to="`/booking/details/${item.booking_id}/${item.id}`">
            <b-button variant="link" class="text-warning px-1 py-0">
              <font-awesome-icon icon="pencil-alt" title="Edit" />
            </b-button>
          </router-link>
        </div>
      </template>
      <template v-slot:cell(username)="{ item }">
        <div>
          <router-link
            :to="`/report/customer/${item.user_guid}`"
            class="text-bold underline"
          >
            {{ item.username }}
          </router-link>
          ({{ item.member_id }})
        </div>
        <div class="time-color">
          {{ item.telephone | moment("HH:mm:ss") }}
        </div>
      </template>
      <template v-slot:cell(booking_date)="{ item }">
        <div>{{ item.booking_date | moment($formatDateNew) }}</div>
        <div class="time-color">
          {{ item.booking_date | moment("HH:mm:ss") }}
        </div>
      </template>
      <template v-slot:cell(created_time)="{ item }">
        <div>{{ item.created_time | moment($formatDateNew) }}</div>
        <div class="time-color">
          {{ item.created_time | moment("HH:mm:ss") }}
        </div>
      </template>
      <template v-slot:cell(updated_time)="{ item }">
        <div>{{ item.updated_time | moment($formatDateNew) }}</div>
        <div class="time-color">
          {{ item.updated_time | moment("HH:mm:ss") }}
        </div>
      </template>
      <template v-slot:cell(sale_branch)="{ item }">
        <div v-if="!item.sale_branch && !item.sale">-</div>
        <div>{{ item.sale_branch || "" }}</div>
        <div class="time-color">
          {{ item.sale || "" }}
        </div>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-black my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">Loading...</strong>
        </div>
      </template>
      <template v-slot:cell(action)="data">
        <b-button
          @click.prevent="submit(data.item)"
          :class="[
            (isList && selectedBookingId.includes(data.item.id)) ||
            (!isList && data.item.id == selectedBooking)
              ? 'btn-custom-primary'
              : 'btn-filter',
          ]"
        >
          <template v-if="isList">
            {{
              selectedBookingId.includes(data.item.id) ? "Selected" : "Select"
            }}
          </template>
          <template v-else>
            {{ data.item.id == selectedBooking ? "Selected" : "Select" }}
          </template>
        </b-button>
      </template>
    </b-table>
    <Pagination
      :pageOptions="pageOptions"
      :filter="filter"
      :rows="rows"
      @pagination="pagination"
      @handleChangeTake="handleChangeTake"
    />

    <template #modal-footer>
      <b-row>
        <b-col class="text-left">
          <b-button @click.prevent="hide(1)" class="border-btn"
            >Cancel</b-button
          >
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import Pagination from "@/components/Pagination";
import BookingTemplateCreate from "@/components/booking/detail/BookingTemplateCreate";
export default {
  name: "ModalBookingList",
  components: {
    Pagination,
    BookingTemplateCreate,
  },
  props: {
    selectedBooking: {
      required: false,
      default: () => [],
    },
    isList: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      showModal: false,
      fields: [
        {
          key: "action",
          label: "Action",
        },
        {
          key: "prefix_id",
          label: "Booking ID.",
        },
        {
          key: "username",
          label: "Booking Contact",
          thClass: "text-center",
          tdClass: "text-left",
        },
        {
          key: "booking_date",
          label: "Booking Date",
        },
        {
          key: "all_service_name",
          label: "Service",
          tdClass: "text-left w-200",
        },
        {
          key: "count_all_ticket",
          label: "Ticket Quantity",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "sale_branch",
          label: "Branch / Staff ID",
          tdClass: "text-left w-200",
        },
        {
          key: "created_time",
          label: "Create Date",
        },
        {
          key: "updated_time",
          label: "Last Updated Date",
        },
      ],
      items: [],
      isBusy: false,
      checkAll: false,
      selectAllCb: false,
      rows: 0,
      showing: 1,
      showingTo: 10,
      checkboxInactive: false,
      checkboxActive: false,
      filter: {
        search: "",
        page: 1,
        take: 5,
      },
      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 20, text: "20 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
    };
  },
  computed: {
    selectedBookingId() {
      return this.selectedBooking.map((data) => data.ticket_relate_ref_id);
    },
  },
  watch: {
    showModal: {
      handler(value) {
        if (value) {
          this.filter = {
            search: "",
            page: 1,
            take: 5,
          };
          this.getList();
        }
      },
    },
  },
  methods: {
    async show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    getList: async function () {
      this.isBusy = true;
      const payload = {
        ...this.filter,
        pageSize: this.filter.take,
      };
      await this.$store.dispatch("getBookingReportList", payload);
      let data = this.$store.state.booking.formList;
      if (data.result == 1) {
        this.items = data.detail.reponse;
        this.rows = data.detail.count;
      }
      this.isBusy = false;
    },
    handleSearch(e) {
      this.filter = {
        ...this.filter,
        ...e,
        page: 1,
      };
      this.getList();
    },
    pagination(value) {
      this.filter.page = value;
      this.getList();
    },
    handleChangeTake(take) {
      this.filter.page = 1;
      this.filter.take = take;
      this.getList();
    },

    submit(item) {
      this.$emit("select", item);
      this.hide();
    },
    colorClass(item) {
      const status = parseInt(item.status);
      if ([3, 4].includes(status)) return "text-error";
      else if (status == 2) return "text-success";
      else if (status == 5) return "text-info";
      else if (status == 1) return "text-warning";
      else return "text-secondary";
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  background-color: var(--theme-secondary-color);
  color: var(--font-color);
  font-weight: 600;
}
::v-deep .modal-dialog {
  max-width: 800px;
}
::v-deep .input-group-text {
  padding: 0;
  background-color: transparent;
}
::v-deep thead {
  background-color: var(--theme-secondary-color);
  color: var(--font-color);
  text-align: center;
}
::v-deep .modal-footer {
  justify-content: space-between;
}
.btn-save {
  color: #fff;
  background-color: var(--primary-color);
  width: 100%;
  border: none;
  padding: 5px 50px;
  border-radius: 0px;
}
.btn-cancel {
  color: #fff;
  background-color: #39424e;
  width: 100%;
  border: none;
  padding: 5px 50px;
  border-radius: 0px;
}

.booking-header {
  display: flex;

  .header {
    width: 100%;
  }

  .button {
    width: 150px;
  }
}

.break-word {
  overflow-wrap: break-word;
}
</style>
